(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sub-collection4-template"] && !Shopify.designMode) return;
  try {
    

(function() {
  function initScrollButtons() {
    const container = document.querySelector('.banner_cate');
    const btnLeft = document.querySelector('.scroll-btn.left');
    const btnRight = document.querySelector('.scroll-btn.right');
    if (!container || !btnLeft || !btnRight) return;

    const scrollAmount = 250; // scroll distance per click

    btnLeft.addEventListener('click', () => {
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    btnRight.addEventListener('click', () => {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

  document.addEventListener('DOMContentLoaded', initScrollButtons);
  document.addEventListener('shopify:section:load', initScrollButtons);
})();

document.addEventListener('DOMContentLoaded', function() {
  const banner = document.querySelector('.banner_cate');
  if (banner) banner.scrollLeft = 0;
});



  } catch(e) { console.error(e); }
})();
})();
